import React from "react";
import { Helmet } from 'react-helmet'
import { StaticImage } from "gatsby-plugin-image"
import Header from '../components/Header2';
import Footer from '../components/Footer';
import { graphql } from "gatsby";

 const Instrukcja: React.FC = () => {
    return (
        <div className="flex flex-col min-h-screen bg-slate-50">
            <Helmet title="Dentobus NFZ Lubuskie - instrukcja dla szkół" defer={false} />
            <Header />
            <main>
                <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800 leading-relaxed">
                    <h1 className="text-2xl font-bold mb-6">
                        Szanowni Państwo,
                    </h1>

                    <p className="mb-4">
                        W związku z planowaną wizytą Dentobusu w Państwa placówce, zwracamy się z
                        uprzejmą prośbą o przesłanie listy uczniów, którzy wezmą udział w
                        badaniach profilaktycznych (tych, których rodzice wyrazili zgodę – w
                        przypadku przedszkolaków, bądź nie wyrazili sprzeciwu – w przypadku
                        dzieci szkolnych).
                    </p>
                    <p className="mb-4">
                        Aby umożliwić sprawne przygotowanie dokumentacji oraz przeprowadzenie
                        badań w systemie NFZ, bardzo prosimy o wykonanie poniższych kroków:
                    </p>

                    <h2 className="text-xl font-semibold mt-8 mb-4">✅ Instrukcja krok po kroku:</h2>
                    <ol className="list-decimal pl-6 space-y-4">
                        <li>
                            <strong>Zalogowanie się do aplikacji "Przeglądy stomatologiczne"</strong>
                            <p>
                                Prosimy kliknąć w przesłany link i zalogować się do aplikacji,
                                używając loginu i hasła, które otrzymali Państwo w tej wiadomości
                                e-mail.
                            </p>
                        </li>
                        <li>
                            <strong>Wyeksportowanie listy uczniów z używanego przez Państwa systemu</strong>
                            <p>(np. Librus, Vulcan, UONET+, itp.)</p>
                            <p>Prosimy wyeksportować listę uczniów w jednym z poniższych formatów:</p>
                            <ul className="list-disc pl-6">
                                <li>CSV</li>
                                <li>XLS (Excel)</li>
                                <li>ODT (Open Office Calc)</li>
                            </ul>
                        </li>
                        <li>
                            <strong>Dostosowanie listy uczniów do wymogów systemu NFZ</strong>
                            <ul className="list-disc pl-6 mt-2">
                                <li>
                                    Imię i nazwisko ucznia muszą znajdować się w osobnych kolumnach.
                                    W przypadku przesłania pliku z imieniem i nazwiskiem w jednej
                                    kolumnie, lista zostanie odesłana do poprawy – taka forma
                                    uniemożliwia jej zaimportowanie do systemu.
                                </li>
                                <li>Lista musi zawierać następujące dane każdego ucznia:</li>
                                <ul className="list-[square] pl-6 mt-1">
                                    <li>Imię</li>
                                    <li>Nazwisko</li>
                                    <li>PESEL</li>
                                    <li>Adres e-mail rodzica/opiekuna prawnego</li>
                                </ul>
                            </ul>
                        </li>
                        <li>
                            <strong>Dodanie poprawnie przygotowanej listy do aplikacji</strong>{" "}
                            <a
                                href="https://lista-uczniow.dentobus-lubuskie.pl/"
                                className="text-blue-600 underline"
                            >
                                https://lista-uczniow.dentobus-lubuskie.pl/
                            </a>
                            <p>
                                Po przygotowaniu pliku należy go załączyć bezpośrednio w aplikacji,
                                w odpowiednim miejscu oznaczonym jako „importuj z pliku”.
                            </p>
                        </li>
                    </ol>

                    <h2 className="text-xl font-semibold mt-10 mb-4">⏰ Harmonogram klas / grup</h2>
                    <p className="mb-4">
                        Dodatkowo prosimy o przesłanie krótkiego harmonogramu badań,
                        wskazującego, która klasa lub grupa wchodzi o której godzinie, np.:
                    </p>
                    <ul className="list-disc pl-6 mb-4">
                        <li>8:00 – klasa 1A</li>
                        <li>9:00 – klasa 3B</li>
                        <li>10:00 – grupa przedszkolna „Biedronki”</li>
                    </ul>
                    <p className="mb-4">
                        🦷 W ciągu jednej godziny jesteśmy w stanie obsłużyć maksymalnie 20-25
                        uczniów (jedna klasa) lub maksymalnie 20 dzieci przedszkolnych.
                    </p>
                    <p className="mb-6">
                        Dzięki prawidłowo wypełnionej liście i harmonogramowi nasz informatyk
                        będzie mógł poprawnie zaimportować dane do systemu dokumentacji
                        elektronicznej.
                    </p>

                    <p className="mb-2">Z góry dziękujemy za współpracę oraz terminowe przesłanie listy uczniów i harmonogramu.</p>

                    <h2 className="text-xl font-semibold mt-8 mb-2">📞 Kontakt w razie pytań:</h2>
                    <ul className="space-y-1">
                        <li>Agata Obrębska – <a href="tel:+48880915204" className="text-blue-600 underline">880 915 204</a></li>
                        <li>Łukasz Obrębski – <a href="tel:+48880915244" className="text-blue-600 underline">880 915 244</a></li>
                    </ul>
                </div>
            </main>
            <Footer />

        </div>
    );
}


export const query = graphql`
 query {
    dentobus: file(relativePath: {eq: "images/dentobus2.jpg"}) {
    childImageSharp {
      fluid(maxHeight: 92) {
        src
        sizes
        srcSet
        srcWebp
        base64
      }
    }
  }
  }
`

export default Instrukcja;